import { reactive } from "vue";
import { throttle } from "lodash";

function controlScroll(querySelector, options = {}) {
  const scrollStatus = reactive({
    scrollTop: 0,
    scrollDom: null,
    isUserControlling: false,
    scrollDirection: "down",
    isScrolling: false,
  });
  let isInit = false;
  let vm;
  let userControllingTimer;
  let scrollingTimer;
  let scrollBottomInterval;
  const LOWER_THRESHOLD = 30;
  const UPPER_THRESHOLD = 20;

  function initParams(vmInstance) {
    vm = vmInstance;
  }
  let preTouchScrollTop;
  let preTouchScrollTopTimer;
  function changeControlByBottom() {
    if (!isInit) return;
    const scrollContainer = scrollStatus.scrollDom;
    // 用户向下滚动时候，如果距离底部小于 LOWER_THRESHOLD px，则滚动交给js控制权
    if (
      scrollContainer.scrollHeight <=
      scrollContainer.scrollTop + scrollContainer.clientHeight + LOWER_THRESHOLD
    ) {
      if (scrollStatus.scrollDirection === "down") {
        scrollStatus.isUserControlling = false;
      }
      // 接近底部
      return true;
    }
    // 不接近底部
    return false;
  }
  async function checkTouchTop() {
    if (!isInit) return;
    const scrollContainer = scrollStatus.scrollDom;
    if (
      scrollContainer.scrollTop < UPPER_THRESHOLD &&
      scrollStatus.scrollDirection === "up"
    ) {
      if (preTouchScrollTop === scrollContainer.scrollTop) return;
      preTouchScrollTop = scrollContainer.scrollTop;
      if (preTouchScrollTopTimer) clearTimeout(preTouchScrollTopTimer);
      preTouchScrollTopTimer = setTimeout(() => {
        // 避免重复触发，和一直不触发的情况
        preTouchScrollTop = null;
      }, 500);
      // 向上滚动触顶了
      if (options.touchTop) {
        options.touchTop();
      }
    }
  }
  let lastScrollTop = 0;
  const scrollHandler = throttle(
    function (e) {
      if (!isInit) return;
      scrollStatus.isScrolling = true;
      checkTouchTop();
      const scrollContainer = scrollStatus.scrollDom;
      if (scrollStatus.isUserControlling === true) {
        // 判断用户操作时候的方向
        if (scrollContainer.scrollTop >= lastScrollTop) {
          scrollStatus.scrollDirection = "down";
        } else {
          scrollStatus.scrollDirection = "up";
        }
      }
      lastScrollTop = scrollContainer.scrollTop;
      // 靠近底部时 滚动由js控制
      changeControlByBottom();
      // console.log(
      //   "是否由用户控制滚动",
      //   scrollStatus.isUserControlling,
      //   scrollStatus.scrollDirection,
      // );
      e.stopImmediatePropagation && e.stopImmediatePropagation();
      if (scrollingTimer) clearTimeout(scrollingTimer);
      scrollingTimer = setTimeout(() => {
        scrollStatus.isScrolling = false;
      }, 500);
    },
    20,
    {
      leading: true,
      trailing: false,
    }
  );
  let cacheTouchPageY;
  function touchEndHandler(e) {
    e.stopPropagation();
    cacheTouchPageY = undefined;
    // console.log("触摸移动停止xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", e);
    changeControlByBottom();
  }
  const touchStartHandler = function (e) {
    // console.log("触摸移动开始--------------------------------", e);
    e.stopPropagation();
    if (scrollStatus.isScrolling) {
      scrollStatus.scrollDirection = "up";
      scrollStatus.isUserControlling = true;
    }
    cacheTouchPageY = undefined;
    const touch = e.targetTouches[0];
    if (!cacheTouchPageY) {
      cacheTouchPageY = touch.pageY;
    }
  };
  const userHandler = throttle(function (e) {
    if (!isInit) return;
    if (e.type === "touchmove") {
      const touch = e.targetTouches[0];
      if (!cacheTouchPageY) {
        cacheTouchPageY = touch.pageY;
      }
      if (cacheTouchPageY > touch.pageY) {
        scrollStatus.scrollDirection = "down";
      } else {
        scrollStatus.scrollDirection = "up";
      }
      cacheTouchPageY = touch.pageY;
    } else {
      if (e.wheelDelta < 0) {
        // 向下滚动
        scrollStatus.scrollDirection = "down";
      } else {
        // 向上滚动
        scrollStatus.scrollDirection = "up";
      }
    }
    // 用户滚动
    scrollStatus.isUserControlling = true;
    checkTouchTop();
    // 用户向下滚动时候，如果距离底部小于 LOWER_THRESHOLD px，则滚动交给js控制权
    changeControlByBottom();
    // console.log("用户操作后的方向", scrollStatus.scrollDirection);
    // clearInterval(scrollBottomInterval);
  }, 20);
  function scrollToTop() {
    if (!isInit) return;
    const scrollContainer = scrollStatus.scrollDom;
    scrollContainer.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  }
  function scrollToBottom(type = "smooth") {
    // type === "smooth" || "immediate"
    if (!isInit) return;
    // 用户操作的时候，不滚动
    if (scrollStatus.isUserControlling) return;
    const scrollContainer = scrollStatus.scrollDom;
    // console.log("执行滚动到底部！！");
    const top = scrollContainer.scrollHeight - scrollContainer.clientHeight;
    if (type === "smooth") {
      scrollContainer.scrollTo({ left: 0, top, behavior: "smooth" });
    } else {
      scrollContainer.scrollTo({ left: 0, top });
    }
  }

  const mixins = {
    mountedAction() {
      let dom;
      dom = document.querySelector(querySelector);

      if (dom) {
        isInit = true;
        scrollStatus.scrollDom = dom;
        scrollStatus.scrollTop = dom.scrollTop;
        scrollStatus.scrollDom?.addEventListener("scroll", scrollHandler);
        scrollStatus.scrollDom?.addEventListener("wheel", userHandler);
        scrollStatus.scrollDom?.addEventListener("touchmove", userHandler);
        scrollStatus.scrollDom?.addEventListener("touchend", touchEndHandler);
        scrollStatus.scrollDom?.addEventListener(
          "touchstart",
          touchStartHandler
        );
      }
    },
    destroyedAction() {
      scrollStatus.scrollDom?.removeEventListener("scroll", scrollHandler);
      scrollStatus.scrollDom?.removeEventListener("wheel", userHandler);
      scrollStatus.scrollDom?.removeEventListener("touchmove", userHandler);
      scrollStatus.scrollDom?.removeEventListener("touchend", touchEndHandler);
      scrollStatus.scrollDom?.removeEventListener(
        "touchstart",
        touchStartHandler
      );
      isInit = false;
    },
  };
  return {
    scrollToTop,
    scrollToBottom,
    scrollStatus,
    initParams,
    mixins,
  };
}

export default controlScroll;
